var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13C18.5 13.4375 18.1562 13.75 17.75 13.75H12.75V18.75C12.75 19.1875 12.4062 19.5312 12 19.5312C11.5625 19.5312 11.25 19.1875 11.25 18.75V13.75H6.25C5.8125 13.75 5.5 13.4375 5.5 13.0312C5.5 12.5938 5.8125 12.25 6.25 12.25H11.25V7.25C11.25 6.84375 11.5625 6.53125 12 6.53125C12.4062 6.53125 12.75 6.84375 12.75 7.25V12.25H17.75C18.1562 12.25 18.5 12.5938 18.5 13Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.600f051afba562bb35305785532139bb.svg";
export { ForwardRef as ReactComponent };